import { RootState } from 'state/store';

export const selectTyrePreCheck = (s: RootState) => ({
    hasBeenRepaired: s.tyreRequest.hasBeenRepaired,
    hasBeenPayed: s.tyreRequest.hasBeenPayed
});
